import * as React from 'react';
import ReactTable, { Column } from 'react-table';
import { dateParser } from '@common/dateParser';
import { TooltipComponent } from '@common/components/tooltip/tooltip.component';
import {
  DocumentHistoryViewModel,
  DocumentMedium,
  DocumentHistoryContentModel,
  DocumentStatus,
  DocumentType
} from '@models/DocumentHistory';
import { Select, DynamicSelectIdentifier, ModalProps } from '@common/components';
import { LocalForm } from 'react-redux-form';
import { DocumentResend } from '../document-resend/document-resend.container';

export interface DocumentHistoryTableComponentProperties {
  readonly message: string;
  readonly documentsLoading: boolean;
  readonly documents: DocumentHistoryViewModel[];
  readonly entityId: number;
  readonly getDocumentHistory: (entityId: number) => void;
  readonly toggleDialog: (content: string) => void;
  readonly toggleModal: (modalProps?: ModalProps) => void;
}

interface FormModel {
  readonly status: string;
}

interface DocumentHistoryTableComponentState {
  type: string;
}

// Component definition
export class DocumentHistoryTableComponent extends React.Component<
  DocumentHistoryTableComponentProperties,
  DocumentHistoryTableComponentState
> {
  private isInitialized: boolean = false;

  constructor(props: DocumentHistoryTableComponentProperties) {
    super(props);
    this.state = {
      type: '-1'
    };
  }

  componentDidMount() {
    this.getDocumentHistory();
  }

  getDocumentHistory() {
    this.props.getDocumentHistory(this.props.entityId);
  }

  renderError() {
    if (!this.props.message) {
      return <div />;
    }
    return <div className="error">{this.props.message.toString()}</div>;
  }

  renderDialog(content: DocumentHistoryContentModel[]) {
    this.props.toggleDialog(content[0].text);
  }

  renderEmail(content: DocumentHistoryContentModel[]) {
    return content.map((doc: DocumentHistoryContentModel, index: number) => (
      <a href={`/api/document/${doc.documentId}/download`} key={doc.documentName}>
        <TooltipComponent side="left" icon={index === 0 ? 'fa-file' : 'fa-paperclip'} relative={true}>
          {doc.documentName}
        </TooltipComponent>
      </a>
    ));
  }

  showResendModal = (emailHistoryId: number, entityId?: number, email?: string) => {
    this.props.toggleModal({
      title: 'Resend Document',
      component: DocumentResend,
      hideSave: true,
      hideX: true,
      closeLabel: 'Cancel',
      isSmall: true,
      closeCallback: () => {
        this.props.toggleModal();
      },
      childProps: {
        emailHistoryId: emailHistoryId,
        entityId: entityId,
        emailAddress: email
      }
    });
  };

  renderActions(id?: number, entityId?: number, email?: string) {
    if (id) {
      return (
        <i
          className="fas fa-envelope red-text pointer"
          onClick={() => {
            this.showResendModal(id, entityId, email);
          }}
        />
      );
    } else {
      return;
    }
  }

  render() {
    const hasDocs = this.props.documents;
    if (!hasDocs) {
      return <h3>No Document History Available</h3>;
    }
    const columns: Column[] = [
      {
        accessor: (d: DocumentHistoryViewModel) => {
          return d.date;
        },
        id: 'date',
        Header: 'Sent Date',
        Cell: (props: { value: string }) => <>{dateParser.parse(props.value).format('l LT')}</>
      },
      {
        accessor: (d: DocumentHistoryViewModel) => {
          return d.recipient;
        },
        id: 'recipient',
        Header: 'Recipient'
      },
      {
        accessor: (d: DocumentHistoryViewModel) => {
          return DocumentMedium[d.medium];
        },
        id: 'medium',
        Header: 'Medium'
      },
      {
        accessor: (d: DocumentHistoryViewModel) => {
          return DocumentStatus[d.status];
        },
        id: 'status',
        Header: 'Delivery Status'
      },
      {
        accessor: (d: DocumentHistoryViewModel) => {
          return DocumentType[d.type];
        },
        id: 'type',
        Header: 'Type'
      },
      {
        style: { overflow: 'visible' },
        accessor: (d: DocumentHistoryViewModel) => {
          return d.medium === DocumentMedium.Email ? (
            this.renderEmail(d.content)
          ) : (
            <a
              href="javascript:void(0);"
              className="ellipsis"
              onClick={() => {
                this.renderDialog(d.content);
              }}
            >
              View
            </a>
          );
        },
        id: 'content',
        Header: 'Content',
        maxWidth: 75
      },
      {
        Header: 'Action',
        id: 'action',
        maxWidth: 60,
        accessor: (d: DocumentHistoryViewModel) => {
          return this.renderActions(d.emailHistoryId, d.entityId, d.recipient);
        }
      }
    ];

    return (
      <div>
        <LocalForm
          className="form-horizontal"
          hideNativeErrors={true}
          model="document-history"
          onSubmit={(props: FormModel) => {
            const val = props.status || -1;
            this.setState({ type: `${val}` });
          }}
        >
          <div className="col-md-4">
            <label htmlFor=".type">Filter By Status:</label>
            <Select
              id="status"
              identifier={DynamicSelectIdentifier.DocumentStatuses}
              model=".status"
              validateOn="change"
            />
          </div>
          <div className="row center-xs text-right">
            <button className="btn btn-primary" type="submit">
              Filter
            </button>
          </div>
        </LocalForm>
        <ReactTable
          onPageChange={() => {
            Array.from(document.getElementsByClassName('rt-tbody')).forEach(element => {
              element.scrollTop = 0;
            });
          }}
          className="-striped -highlight"
          columns={columns}
          data={this.filter()}
          loading={this.props.documentsLoading}
          manual={true}
          onFetchData={this.handleFetchData}
        />
      </div>
    );
  }

  private filter = () => {
    return this.props.documents.filter(value => {
      return value.status === +this.state.type || this.state.type === '-1';
    });
  };

  private handleFetchData = (): void => {
    if (this.isInitialized) {
      this.props.getDocumentHistory(this.props.entityId);
    }

    this.isInitialized = true;
  };
}



// WEBPACK FOOTER //
// ./src/document-history/_components/document-history-table/document-history-table.component.tsx